import {Component, Input} from '@angular/core';
import {
  MatCardModule,
} from "@angular/material/card";
import {Condition} from "../condition";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";

@Component({
  selector: 'app-condition-card',
  imports: [
    CommonModule,
    MatCardModule,
    NgOptimizedImage,
  ],
  templateUrl: './condition-card.component.html',
  styleUrl: './condition-card.component.scss'
})

export class ConditionCardComponent {
  @Input() condition!: Condition;
  @Input() sanitizer!: DomSanitizer;

  getBackgroundImage(url: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
  }

}
